export default {
  getUserInfo (state) {
    if (state.userInfo === null) {
      return {}
    }
    return state.userInfo
  }
}
